import styled from 'styled-components';

/* The rail is set apart by its own surface alone. A 1px border on top of it
   fought both neighbouring surfaces in dark mode, where the border token is
   lighter than the rail but not than the card around it. */
const List = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ theme }) => theme.backgrounds.workspaceItem};
  border-radius: 4px;
  overflow: hidden;

  @media (max-width: 1024px) {
    flex-direction: row;
    overflow-x: auto;
    scrollbar-width: thin;
  }
`;

export default List;
